module.exports = __webpack_public_path__ + "41395333c19145e5cc29981d5901a21e.png";